import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { EMAIL_SUPPORT_URL, REDIRECT_ROUTES, SUPERUSER_LEVEL } from '../constants';
import { hasSuperuserAccess } from '../utils';
import { useAuth } from '../components/context';

function Errors({ status }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const goBackRoute = hasSuperuserAccess(user, [SUPERUSER_LEVEL.FULL_ACCESS])
    ? REDIRECT_ROUTES.ADMIN_HOME
    : REDIRECT_ROUTES.USER_HOME;
  return (
    <Container className="error splash main-content-container d-flex flex-grow-1 p-5">
      <div className="splash__content align-self-center">
        <i className="sila-icon sad-cloud" />
        {(status === 404 || status === 500) && <h2>{status}</h2>}
        {status === 404 && (
          <>
            <h3>{t('errors.404.title')}</h3>
            <p className="text-lg">{t('errors.404.description')}</p>
          </>
        )}
        {status === 500 && (
          <>
            <h3>{t('errors.500.title')}</h3>
            <p className="text-lg">{t('errors.500.description')}</p>
          </>
        )}
        {status === 'frozen' && (
          <>
            <h3>{t('errors.frozen.title')}</h3>
            <p className="text-lg">{t('errors.frozen.description1')}</p>
            <p>
              <Trans i18nKey="errors.frozen.description2">
                Please contact our
                <a href={EMAIL_SUPPORT_URL}>Customer Success Team</a> to request access. We will
                review your request within 2 business days.
              </Trans>
            </p>
            <p className="text-info text-center">{t('errors.frozen.note')}</p>
          </>
        )}
        <Button className="back" onClick={() => navigate(goBackRoute)}>
          {t('common:buttons.goBack')}
        </Button>
      </div>
    </Container>
  );
}

export default Errors;
